export default __webpack_public_path__ + "static/media/Recipes-Dishes.c691407b.png";